import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const ROOTS = ["/", "/compte"];

export const BackButton = () => {
  const { pathname, key } = useLocation();
  const navigate = useNavigate();
  if (ROOTS.includes(pathname)) return null;
  const fallback = pathname.startsWith("/compte/") ? "/compte" : "/";
  const back = () => (key !== "default" && window.history.length > 1 ? navigate(-1) : navigate(fallback));
  return (
    <div className="max-w-lg mx-auto px-4 pt-3 -mb-4 w-full">
      <button onClick={back} data-testid="page-back-button"
        className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors">
        <ArrowLeft className="w-4 h-4" /> Retour
      </button>
    </div>
  );
};
